import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1c57cd20")

_pushScopeId("data-v-1c57cd20")
const _hoisted_1 = { class: "md:flex flex-col md:flex-row md:min-h-screen mt-4 mx-4" }
const _hoisted_2 = {
  class: "md:col-span-1 md:grid-cols-1",
  style: {"display":"unset"}
}
const _hoisted_3 = { class: "mx-auto w-full text-white col-start-3 md:col-span-6 md:grid-cols-6 justify-self-center lg:justify-self-stretch" }
const _hoisted_4 = { class: "mt-7 md:mt-5 lg:mx-auto max-w-4xl" }
const _hoisted_5 = { class: "mx-auto md:max-w-lg lg:max-w-full mt-4" }
const _hoisted_6 = { class: "md:mx-4 lg:mx-12 flex-col sm:flex-row md:items-center md:flex flex-wrap justify-center items-center justify-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_sidebar_profile = _resolveComponent("sidebar-profile")
  const _component_search = _resolveComponent("search")
  const _component_Filter = _resolveComponent("Filter")
  const _component_default_boostpack_card_layout = _resolveComponent("default-boostpack-card-layout")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_sidebar_profile)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", null, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_search)
        ]),
        _createVNode("div", _hoisted_5, [
          _withDirectives(_createVNode(_component_Filter, null, null, 512), [
            [_vShow, false]
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_default_boostpack_card_layout, { "enable-edit-subscription": true })
        ])
      ])
    ])
  ]))
})